module.exports = __webpack_public_path__ + "img/qrCode1.326b55d9.png";